let data_event_id = sessionStorage.getItem("data_event_id") || "10016";

window.addEventListener("DOMContentLoaded", function () {
  let hasExecuted = false;

  const scrollObserver = new IntersectionObserver(
    (entries) => {
      if (!hasExecuted && entries[0].isIntersecting) {
        hasExecuted = true;
        initTrackingCode();
        scrollObserver.disconnect();
      }
    },
    { threshold: 0.01 }
  );

  scrollObserver.observe(document.documentElement);
});

/* =======================
   初始化
======================= */
function initTrackingCode() {
  window.dataLayer = window.dataLayer || [];

  /* =======================
     常量 & 工具方法
  ======================= */

  const CATEGORY_MAP = {
    "Matrix Series": "Robot Vacuum",
    "Aqua Series": "Robot Vacuum",
    "X Series": "Robot Vacuum",
    "L Series": "Robot Vacuum",
    "D Series": "Robot Vacuum",

    "H15 Series": "Wet and Dry Vacuums",
    "H14 Series": "Wet and Dry Vacuums",
    "H12 Series": "Wet and Dry Vacuums",
    "G Series": "Wet and Dry Vacuums",

    "Z Series": "Cordless Stick Vacuums",
    "R Series": "Cordless Stick Vacuums",

    "Hair Styler": "Hair Care",
    "Hair Dryer": "Hair Care",
    "Hair Dryers": "Hair Care",
    "Hair Straightener": "Hair Care",

    "PM Series": "Air Purifiers",
    "AirPursue": "Air Purifiers",

    "Pool Vacuum": "Robotic Pool Cleaners",
    "Pool Skimmer": "Robotic Pool Cleaners",
  };

  function parsePrice(text = "") {
    return parseFloat(text.replace(/[^0-9.]/g, "")) || 0;
  }

  function getItemIndex(container, selector, target) {
    const list = Array.from(container.querySelectorAll(selector));
    const index = list.indexOf(target);
    return index > -1 ? index : 0;
  }

  function getItemBaseData(container, index = 0) {
    if (!container) return null;

    // const idInput = container.querySelector("input[name='id']");
    const idInput = container.querySelector("input.home_product_id");
    // console.log(idInput,'111111');
    const categoryInput = container.querySelector(
      "input[name='product-category']"
    );
    const titleInput = container.querySelector("input.home_product_title");
    const priceEl1 = container.querySelector(".on-sale");
    const priceEl2 = container.querySelector("input.home_product_price");

    const rawCategory = categoryInput?.value;
    const item_category = rawCategory
      ? CATEGORY_MAP[rawCategory] || rawCategory
      : "unknown-category";
    const item_price =
      parsePrice(priceEl1?.textContent) || parsePrice(priceEl2?.value);

    return {
      item_id: idInput?.value?.trim() || `unknown-id-${Date.now()}`,
      item_name: titleInput?.value?.trim() || "Unknown Product",
      item_category,
      item_brand: "dreame",
      price: item_price,
      index,
      quantity: 1,
    };
  }

  function getShowcaseTitle(showcase) {
    const $showcase = $(showcase);
    const $inner = $showcase.find(".showcase-data-title").last();
    if ($inner.length) return $inner.text().trim();

    const $outer = $showcase.prevAll(".showcase-data-title").first();
    return $outer.length ? $outer.text().trim() : "Product Showcase";
  }

  /* =======================
     Banner 曝光
  ======================= */
  triggerResizeOnEnterViewport(".prime-data-banner", function () {
    const title = $(".prime-data-title").text().trim();
    window.dataLayer.push({
      event: "view_promotion",
      promotion_id: `${data_event_id}`,
      creative_name: "Banner",
      creative_slot: "Banner_1",
      promotion_name: title,
    });
  });

  /* =======================
     导航点击
  ======================= */
  $(".new-common-tabbar .common-tabbar-item").on("click", function () {
    window.dataLayer.push({
      event: "Deal_event",
      event_category: "Deal campaign Tab",
      event_label: $(this).text().trim(),
    });
  });

  /* =======================
     商品曝光
  ======================= */
  const showcases = document.querySelectorAll(".common-p-showcase");

  const showcaseObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const showcase = entry.target;
        const items = [];

        showcase.querySelectorAll(".custom-item").forEach((item, idx) => {
          const data = getItemBaseData(item, idx);
          if (data) items.push(data);
        });

        if (items.length) {
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              item_list_id: `${data_event_id}`,
              item_list_name: getShowcaseTitle(showcase),
              items,
            },
          });
        }

        observer.unobserve(showcase);
      });
    },
    { threshold: 0.1 }
  );

  showcases.forEach((el) => showcaseObserver.observe(el));

  /* =======================
     Add to Cart
  ======================= */
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".common-add-cart");
    if (!btn) return;

    const container = btn.closest(".common-p-showcase");
    const productBox = btn.closest(".all_info");
    if (!container || !productBox) return;

    const index = getItemIndex(container, ".common-add-cart", btn);
    const item = getItemBaseData(productBox, index);

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "USD",
        value: item.price,
        items: [item],
      },
    });
  });

  /* =======================
     Buy Now
  ======================= */
  // document.addEventListener("click", function (e) {
  //   const btn = e.target.closest(".buy-now-placeholder");
  //   if (!btn) return;

  //   const container = btn.closest(".common-p-showcase");
  //   const productBox = btn.closest(".all_info");
  //   if (!container || !productBox) return;

  //   const index = getItemIndex(container, ".buy-now-placeholder", btn);
  //   const item = getItemBaseData(productBox, index);

  //   window.dataLayer.push({ ecommerce: null });

  //   window.dataLayer.push({
  //     event: "begin_checkout",
  //     ecommerce: {
  //       currency: "USD",
  //       value: item.price,
  //       items: [item],
  //     },
  //   });
  // });

  /* =======================
     商品点击
  ======================= */
  document.addEventListener("click", function (e) {
    const imageLink = e.target.closest(
      ".common-p-showcase .custom-item .image > a, .common-p-showcase .custom-item .xmas-swiper-card-image"
    );
    
    const titleLink = e.target.closest(
      ".common-p-showcase .custom-item .content .common-title a"
    );

    if (!imageLink && !titleLink) return;

    const clickType = imageLink ? "image" : "title";
    const clickTarget = imageLink || titleLink;

    const itemDom = clickTarget.closest(".custom-item");
    if (!itemDom) return;

    if (
      (clickType === "image" &&
        itemDom.dataset.selectItemImageTracked === "1") ||
      (clickType === "title" && itemDom.dataset.selectItemTitleTracked === "1")
    ) {
      return;
    }

    const container = itemDom.closest(".common-p-showcase");
    if (!container) return;

    const index = getItemIndex(container, ".custom-item", itemDom);
    const item = getItemBaseData(itemDom, index);

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_id: `${data_event_id}`,
        item_list_name: `${item.item_name} item click`,
        items: [item],
      },
    });

    if (clickType === "image") {
      itemDom.dataset.selectItemImageTracked = "1";
    } else {
      itemDom.dataset.selectItemTitleTracked = "1";
    }
  });

  /* =======================
     其他按钮点击（仅圣诞）
  ======================= */
  document.addEventListener("click", function (e) {
    const itemDom = e.target.closest(".image-mark .learn_more_btn");
    if (!itemDom) return;

    if (itemDom.dataset.selectItemTracked === "2") return;

    const container = itemDom.closest(".common-p-showcase");
    if (!container) return;

    let item_list_name = getShowcaseTitle(container);
    const itemDomFather = itemDom.closest(".image-mark");
    const item = getItemBaseData(itemDomFather, 0);

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_id: `${data_event_id}`,
        item_list_name: item_list_name,
        items: [item],
      },
    });

    itemDom.dataset.selectItemTracked = "2";
  });

  /* =======================
     获取商品信息
  ======================= */

  const nextBtn = document.querySelector(
    ".chir25main3-showcase-bundle .swiper-button-next"
  );

  if (nextBtn) {
    let clickCount = 0; // 点击次数计数

    nextBtn.addEventListener("click", () => {
      clickCount += 1;

      if (clickCount === 1) {
        window.dataLayer.push({ ecommerce: null });
        // 第一次点击埋点产品1
        window.dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            item_list_id: `${data_event_id}`,
            item_list_name: "Get 1 Year of Accessories with Your Device",
            items: [
              {
                item_brand: "dreame",
                item_category: "Hair Care",
                item_id: "14714308788596",
                item_name: "Dreame AirStyle Pro Hair Styler + Travel Case",
                price: 189.99,
                quantity: 1,
                index: 0,
              },
            ],
          },
        });
      } else if (clickCount === 2) {
        window.dataLayer.push({ ecommerce: null });
        // 第二次点击埋点产品2
        window.dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            item_list_id: `${data_event_id}`,
            item_list_name: "Get 1 Year of Accessories with Your Device",
            items: [
              {
                item_brand: "dreame",
                item_category: "Air Purifiers",
                item_id: "14883093545332",
                item_name: "Dreame AirPursue PM20-Free Activated Carbon Filter",
                price: 599.99,
                quantity: 1,
                index: 0,
              },
            ],
          },
        });

        // 如果只需要两次有效点击，可以保持 clickCount=2
        clickCount = 2;
      }
    });
  }

  /* =======================
     Subscribe 点击（仅圣诞）
  ======================= */
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("button.needsclick.go300628013");
    if (!btn) return;

    window.dataLayer.push({
      event: "subscribe_click",
      promotion_id: `${data_event_id}`,
      event_category: "engagement",
      event_action: "click",
      event_label: "Subscribe Button",
      button_text: btn.innerText.trim(),
    });
  });
}
